export const experimentTester = {
  drawerTitle: "Experiment Tester",
  settings: "Settings",
  settingsAriaLabel: "Open experiment tester settings",
  persistGroups: "Persist groups",
  resetLocalPreference: "Local preference",
  resetLocalPreferenceDescription: "Reset all local preferences saved to local storage",
  resetItemRecentFlippers: "Recent flippers",
  resetItemSandboxOverrides: "Flipper sandbox overrides",
  sandboxModeLabel: "Sandbox mode",
  sandboxModeDescription:
    "Flipper changes are applied to your session only via a local cookie. Shared state is untouched until you turn this off.",
  sandboxStatusOn: "Sandbox on",
  sandboxStatusOff: "Sandbox off",
  sandboxTooltipOn:
    "Sandbox mode is on. Flipper changes are applied to your session only via a local cookie — shared state is untouched.",
  sandboxTooltipOff:
    "Sandbox mode is off. Flipper changes affect the shared environment state for everyone.",
  sandboxModeWarningTitle: "Sandbox overrides don't cover async contexts",
  sandboxModeWarningLabel:
    "Only frontend checks and backend checks during your HTTP requests use your overrides. Background jobs, cron tasks, webhooks, and subscription broadcasts from after_commit hooks still use shared flipper state.",
  localOverrideChip: "Local",
  localOverrideTooltip: "This flipper is overridden only for your session via sandbox mode",
  close: "Close",

  tabs: {
    abTests: "A/B Tests",
    flippers: "Flippers",
  },

  abTests: {
    experiments: "Experiments",
    group: "Group",
    persistGroups: "Persist groups",
  },

  flippers: {
    filterByTeam: "Filter by team",
    searchLabel: "Search for flipper(s)",
    allTeams: "All teams",
    loadingMessage: "Loading loading loading, keep the flippers loading, show/hide!",
    tableHeader: "Flippers",
    statusHeader: "Status",
    noTeam: "No team",
    reset: "Reset",
    resetAriaLabel: "Reset the flippers to the production state",
    sync: "Sync",
    syncAriaLabel: "Sync the flippers to the production state",
  },

  flipper: {
    recent: "Recent",
    recentTooltip: "This flipper was recently enabled locally",
    exposeTooltip:
      "This will close the drawer and expose the flipper toggle inside a toast instead.",
    exposeAriaLabel: "Expose flipper toggle inside toast",
    copyTooltip: "Copy flipper name",
    copyAriaLabel: "Copy flipper name",
    on: "On",
    off: "Off",
  },

  flipperToast: {
    status: "Status:",
    enabled: "Enabled",
    disabled: "Disabled",
  },
} as const;
